import BaseAbstract from '@/abstract/BaseAbstract'
import IOService from '@/service/IOService'

class Service extends BaseAbstract {
  displayName = '品牌'
  name = 'MallBrand'
  cacheDatas = [] as any[]

  index (params: { page: number }) {
    return IOService.get('mall_brand', params)
  }

  indexAll () {
    return IOService.get('mall_brand/indexAll')
      .then((res) => {
        this.cacheDatas = res.data
        return res
      })
  }

  store (params: object) {
    return IOService.post('mall_brand', params)
  }

  show (id: number) {
    return IOService.get(`mall_brand/${id}`)
  }

  update (params: { id: number }) {
    return IOService.put(`mall_brand/${params.id}`, params)
  }

  destroy (id: number | string) {
    return IOService.delete(`mall_brand/${id}`)
  }

  getList () {
    return Promise.resolve()
      .then(() => {
        if (this.cacheDatas.length === 0) {
          return this.indexAll()
        }
      })
      .then(() => this.cacheDatas)
  }
}

export default new Service()
